export const transformDataToFormData = (data) => {
    const formData = new FormData();

    const appendFormData = (data, parentKey = '') => {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const value = data[key];
                const formKey = parentKey ? `${parentKey}[${key}]` : key;

                if (value instanceof File) {
                    formData.append(formKey, value);
                } else if (Array.isArray(value)) {
                    value.forEach((element, index) => {
                        if (element instanceof File) {
                            formData.append(formKey, element);
                        } else if (typeof element === 'object' && element !== null) {
                            appendFormData({[index]: element}, formKey);
                        } else {
                            const elementToAppend = typeof element === 'boolean' ? (element ? 1 : 0) : element;
                            formData.append(`${formKey}[${index}]`, elementToAppend);
                        }
                    });
                } else if (typeof value === 'object' && value !== null) {
                    appendFormData(value, formKey);
                } else if (value !== null && value !== undefined) {
                    const valueToAppend = typeof value === 'boolean' ? (value ? 1 : 0) : value;
                    formData.append(formKey, valueToAppend);
                }
            }
        }
    };

    appendFormData(data);
    return formData;
}

export const transformObjectToGetRequestParams = (data) => {
    const params = new URLSearchParams();

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            const value = data[key];

            if (value instanceof Date) {
                params.append(key, value.toISOString());
            } else if (Array.isArray(value)) {
                value.forEach((element) => {
                    if (element !== null && element !== undefined) {
                        params.append(`${key}[]`, element);
                    }
                });
            } else if (typeof value === 'object') {
                for (const innerKey in value) {
                    if (value.hasOwnProperty(innerKey)) {
                        const innerValue = value[innerKey];
                        if (innerValue !== null && innerValue !== undefined) {
                            params.append(key, innerValue);
                        }
                    }
                }
            } else if (value !== null && value !== undefined) {
                params.append(key, value);
            }
        }
    }

    return params;
};